import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Link } from 'plurall-ui'

const ConnectionParagraph = ({ connectionType, connections }) => {
  const title = connectionType ? connectionType.entity.name : null

  return (
    !!connections.length && (
      <>
        <h4>{title}</h4>
        <div>
          {connections.map(connection => (
            <li key={connection.entity.url.path}>
              <Link
                href={connection.entity.url.path}
                target={externalLink(connection.entity.url.path)}
              >
                {connection.entity.title}
              </Link>
            </li>
          ))}
        </div>
      </>
    )
  )
}

const externalLink = link => {
  const pattern = new RegExp('^(https?|ftp)://')

  if (pattern.test(link) && !link.includes(document.domain)) {
    return '_blank'
  }

  return '_self'
}

ConnectionParagraph.propTypes = {
  connectionType: PropTypes.shape({
    entity: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  connections: PropTypes.array,
}

const fragments = {
  paragraph: gql`
    fragment ConnectionParagraphFragment on ParagraphConnection {
      id
      connectionType: fieldConnectionType {
        targetId
        entity {
          entityId
          name
        }
      }
      connections: fieldConnection {
        targetId
        entity {
          entityId
          title
          url: entityUrl {
            path
          }
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { ConnectionParagraph, fragments }
